import { FC, memo } from 'react';
import { call } from '@/services/call';
import { selectUserAvatar, selectUserVideoEnabled } from '@/store/features/user/selectors';
import { useAppSelector } from '@/store/hooks';
import { StyledAvatar, StyledLocalVideo } from './styled';

type Props = {
  children?: React.ReactNode;
  absolute?: boolean;
}

const LocalVideo: FC<Props> = ({ children, absolute }) => {
  const avatar = useAppSelector(selectUserAvatar);
  const videoEnabled = useAppSelector(selectUserVideoEnabled);

  return (
    <StyledLocalVideo
      mirrored
      id={call.localElementId}
      $absolute={absolute}
    >
      {!videoEnabled ? children || <div className="local-avatar"><StyledAvatar name={avatar} /></div> : null}
    </StyledLocalVideo>
  );
};

export default memo(LocalVideo);
